export default {
    install: () => {}
}
